import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-widget-lang-selector',
  templateUrl: './widget-lang-selector.component.html',
})
export class WidgetLangSelectorComponent implements OnInit {
  public _langs: string[] = [];
  public currentLang: string;

  constructor(
    private readonly router: Router,
    readonly translateService: TranslateService
  ) {}

  public ngOnInit(): void {
    this.currentLang = this.translateService.currentLang;
  }

  @Input()
  public set langs(langs: string[]) {
    if (!langs?.length) {
      return;
    }

    this._langs = langs;
  }

  public get langs(): string[] {
    return this._langs;
  }

  /**
   * Adapt lang for selector display
   */
  public formatLang(lang: string): string {
    return lang.split('-')[1];
  }

  /**
   * Updates selector interface and URL.
   *
   */
  public setLang(lang: string): void {
    if (this.currentLang === lang) {
      return;
    }

    const currentUrl = this.router.url;
    window.location.assign(
      currentUrl.replace(`/${this.currentLang}`, `/${lang}`)
    );
  }
}
